import Swiper from "swiper";
import { EffectFade, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";

export default function initTestimonialSlider() {
  const testimonial_slider = document.querySelector(
    ".testimonials-slider__slider",
  );
  const testimonial_slider_selectors = document.querySelectorAll(
    ".testimonials-slider__pagination > li",
  );
  let testimonial_slider_selectors_array;
  let testimonial_slider_swiper;

  if (testimonial_slider) {
    testimonial_slider_swiper = new Swiper(testimonial_slider, {
      modules: [EffectFade, Autoplay],
      //enabled: false,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      allowTouchMove: false,
      autoplay: {
        delay: 20000,
      },
      on: {
        slideChange: (swiper) => {
          const index = swiper.activeIndex;
          if (
            document.querySelector(
              ".testimonials-slider__pagination > li.current",
            )
          ) {
            document
              .querySelector(".testimonials-slider__pagination > li.current")
              .classList.remove("current");
          }
          testimonial_slider_selectors[index].classList.add("current");
        },
      },
      /*breakpoints: {
				601: {
					enabled: true,
				},
			},*/
    });

    if (testimonial_slider_selectors) {
      testimonial_slider_selectors_array = [...testimonial_slider_selectors];
      testimonial_slider_selectors[0].classList.add("current");
      testimonial_slider_selectors.forEach((selector) => {
        selector.addEventListener("click", () => {
          if (
            document.querySelector(
              ".testimonials-slider__pagination > li.current",
            )
          ) {
            document
              .querySelector(".testimonials-slider__pagination > li.current")
              .classList.remove("current");
          }
          selector.classList.add("current");
          const index = testimonial_slider_selectors_array.indexOf(selector);
          testimonial_slider_swiper.slideTo(index);
        });
      });
    }
  }

  const section = document.querySelector(".testimonials-slider");
  if (!section) return;

  const load = () => {
    section.querySelectorAll("[data-bg]").forEach((el) => {
      el.style.backgroundImage = el.dataset.bg;
    });
  };

  if (!("IntersectionObserver" in window)) {
    load();
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].isIntersecting) {
        load();
        observer.disconnect();
      }
    },
    { rootMargin: "200px" },
  );

  observer.observe(section);
}
